import { render, staticRenderFns } from "./view-trip.vue?vue&type=template&id=5542637d"
import script from "./view-trip.vue?vue&type=script&lang=js"
export * from "./view-trip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports